<template>
  <div class="tariffs">
    <h1 class="main-title">{{ __('website.tariffs.header_H1') }}</h1>
    <TariffCalc />
    <AdditionalFeatures />
    <TariffDesc />
  </div>
  <div class="outer-wrap">
    <FaqBlock />
    <StartWIth />
  </div>

</template>

<script>
import { getPrices, getTranslations } from '@/utils';
import { currencies } from '@/mainData';

import TariffCalc from '@/components/tariffCalc';
import TariffDesc from '@/components/tariffDesc';
import FaqBlock from '@/components/faqBlock';
import StartWIth from '@/components/StartWIth';
import AdditionalFeatures from '@/components/AdditionalFeatures';

export default {
  name: 'App',

  components: {
    TariffCalc,
    TariffDesc,
    FaqBlock,
    StartWIth,
    AdditionalFeatures,
  },


  created() {
    getPrices()
      .then(data => {
        currencies.usd.price = data.find(el => el.cc === 'USD').rate;
        currencies.eur.price = data.find(el => el.cc === 'EUR').rate;
      })
      .catch(() => alert('Can\'t get prices'));
    
    const filePath = process.env.NODE_ENV === 'development'
      ? '/localiseLang/:lang.json?v=4'
      : '/wp-content/uploads/localiseLang/:lang.json?v=4';

    getTranslations(filePath.replace(':lang', this.$localization.lang))
      .then(data => this.$localization.translations = data)
      .catch(() => alert('Can\'t get translations'));
  },
};
</script>

<style lang="sass" scoped>
.tariffs
  background: #292F42
  padding: 40px 16px 48px
  margin: 105px 0 0
.main-title
  font-weight: 700
  font-size: 48px
  line-height: 72px
  text-align: center
  color: #fff
.outer-wrap
  margin: 0 16px

@media screen and (max-width: 999px)
  .tariffs
    padding: 32px 16px 40px

@media screen and (max-width: 992px)
  .tariffs
    margin: 47px 0 0

@media screen and (max-width: 599px)
  .tariffs
    padding: 32px 16px
</style>